var layer1 = promokit.layer({
    el: '#layer-server',
    buttons: '.p-btn__server',
    render:true
});

layer1.on("openstart", ()=>{
    gtag('config', 'UA-137591305-1', {'page_title': '추억의 서버 목록 확인하기', 'page_path':'/virtual/server'});
});

var articleId = {
    local: ['5f7cfdd5170547000185e87c', '5f7cfdd7170547000185e87d', '5f7cfdd8170547000185e87e'],
    op: ['5f7cfdd5170547000185e87c', '5f7cfdd7170547000185e87d', '5f7cfdd8170547000185e87e'],
    rc: ['5f7d22f756d6b8000132e585', '5f7d22f556d6b8000132e584', '5f7d22f756d6b8000132e586'],
    live: ['5f7d3fac1f27df00015ff895', '5f7d3fade950df000110d4cb', '5f7d3fad5175e900017a7b6f']
};

var tab = promokit.tab({
    el: '#tab-menu',
    initActive: 2,
    fade: false,
    text: {
        0: '1주차 내 낡은 인벤 속의 아이템 10. 28. (수) 정기점검 후 ~ 11. 03.(화)',
        1: '1주차 내 낡은 서랍 속의 아이온 10. 28. (수) 정기점검 후 ~ 11. 03.(화)',
        2: '2주차 그 시절 그 사연 11. 04. (수) 정기점검 후 ~ 11. 10.(화)',
    }
});

$.each(tab.$config.alert, function(key, value){
    $(`${tab.$config.el}`).find(".promokit-tab__link").eq(key).addClass("promokit-tab__link--disabled");
});

var page = promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'white' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        home: true,
        event: true,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    comment:[
        {
            el:'#comment1',
            commentTextMaxCount: 300,
            commentListSize: 10,
            articleId: articleId[promokit.util.getNetwork()][0],
            isCommentUpload: true,
            isMultiCommentArticleId:true,
            isCommentUpdate:true,
            adminCommentImg:'https://wstatic-cdn.plaync.com/aion/v1/img/common/admin-tazz.jpg'
        },
        {
            el:'#comment2',
            commentTextMaxCount: 300,
            commentListSize: 10,
            articleId: articleId[promokit.util.getNetwork()][1],
            isCommentUpload: true,
            isMultiCommentArticleId:true,
            isCommentUpdate:true,
            adminCommentImg:'https://wstatic-cdn.plaync.com/aion/v1/img/common/admin-tazz.jpg'
        },
        {
            el:'#comment3',
            commentTextMaxCount: 300,
            commentListSize: 10,
            articleId: articleId[promokit.util.getNetwork()][2],
            isCommentUpload: true,
            isMultiCommentArticleId:true,
            isCommentUpdate:true,
            adminCommentImg:'https://wstatic-cdn.plaync.com/aion/v1/img/common/admin-tazz.jpg'
        }
    ]
});

// 이벤트 종료
$(".p-sec1").append("<div class='event-end'></div>");
$("#tab-menu").remove();



// WEBPACK FOOTER //
// ./src/js/index.js